// extracted by mini-css-extract-plugin
export default {"alertBody":"psXsw75Diq8bov973ozX","alertTitle":"zMlJheSAacnKatcpSiyw"};